import { Client } from '@/common/services/Client';

interface ChangeRenewalStatusRequest {
  status: string;
}

export async function changeRenewalStatus(
  renewalUuid: string,
  status: string,
): Promise<void> {
  const response = await Client.post<void, ChangeRenewalStatusRequest>({
    body: {
      status: status,
    },
    endpoint: `/renewals/${renewalUuid}/status`,
  });
  return response.data;
}
